import React, { useState } from "react";
import PropTypes from "prop-types";
import "../dashboard/css/helpmodal.css";
import { FaTimes, FaPhoneAlt } from "react-icons/fa";

const Helpmodel = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    business: "",
    service: "",
    message: "",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.service ||
      !formData.message
    ) {
      alert("⚠️ Please fill all required fields before submitting.");
      return;
    }

    const whatsappNumber = "919601961116";

    const whatsappMessage = `
🚀 *New Business Enquiry – BizzMark India*

👤 Name: ${formData.name}
📧 Email: ${formData.email}
📞 Phone: ${formData.phone}
🏢 Business: ${formData.business || "Not provided"}
🛠 Service: ${formData.service}

📝 Requirement:
${formData.message}
    `;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappURL, "_blank");

    setFormData({
      name: "",
      email: "",
      phone: "",
      business: "",
      service: "",
      message: "",
    });

    onClose();
  };

  return (
    <div className="helpmodal-overlay">
      <div className="helpmodal-box">
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>
<br />
        <h2>Grow Your Business With Experts</h2>
        <p>
          Share your requirement and our <strong>BizzMark India</strong> team will connect with you shortly.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            required
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            required
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="business"
            placeholder="Business / Company Name"
            value={formData.business}
            onChange={handleChange}
          />

          <select
            name="service"
            value={formData.service}
            required
            onChange={handleChange}
          >
            <option value="">Select Required Service</option>
            <option>Digital Marketing</option>
            <option>Website Design & Development</option>
            <option>SEO (Search Engine Optimization)</option>
            <option>Google Ads / Meta Ads</option>
            <option>Social Media Marketing</option>
            <option>Branding & Graphic Design</option>
            <option>Other</option>
          </select>

          <textarea
            name="message"
            rows="3"
            placeholder="Briefly describe your requirement..."
            value={formData.message}
            required
            onChange={handleChange}
          ></textarea>

          {/* ✅ Simple Submit Button */}
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>

        <div className="direct-contact">
          <span>Prefer to talk directly?</span>
          <a href="tel:+919601961116" className="call-link">
            <FaPhoneAlt /> Call +91 96019 61116
          </a>
        </div>
      </div>
    </div>
  );
};

Helpmodel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Helpmodel;